import clm from 'country-locale-map';
import { environment } from './environment';
import { isAmazonHost } from './isAmazonHost';
import { getRedirectUrl } from './redirectUrl';

const setCookie = (cname: string, cvalue: string, exdays: number) => {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${cname}=${encodeURIComponent(cvalue)};path=/`;
};

// use next line to change locale with cookie
// setCookie('chosen_country', 'ES', 0);

const getCookie = (cname: string) => {
  const name = cname + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
};

const getLocale = () => {
  const extractAmazonCookieLocale = () => {
    const country = window.location.hostname.split('.')?.at(-1)?.toLowerCase();
    return getCookie(`lc-acb${country}`);
  };

  const locale =
    getRedirectUrl()?.locale ||
    environment.locale ||
    (isAmazonHost() && extractAmazonCookieLocale()) ||
    clm.getCountryByAlpha2(getCookie('chosen_country'))?.default_locale ||
    navigator.languages?.[0] ||
    'en-EU';

  // return normalized to hypen format always
  return locale.replace('_', '-');
};

export { getCookie, setCookie, getLocale };
